import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import {CommonModule} from '@angular/common';
import {ViewportService} from '../../services/viewport.service';

@Component({
    selector: 'app-countdown-banner',
    templateUrl: './countdown-banner.component.html',
    styleUrls: ['./countdown-banner.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class CountdownBannerComponent implements OnInit, OnDestroy, OnChanges {
    @Input() banner_txt = '';
    @Input() displaySalesBanner = false;
    @Input() partnerId = '';
    @Input() smallScreen = false;
    @Input() trialDays?: string;
    @Input() trialCode = false;
    seconds = 0;
    minutes = 0;
    hours = 0;

    shouldShowBanner = false;
    bannerMessage = '';

    private timerId?: number;


    constructor(public viewport: ViewportService) { }

    get isMobile(): boolean {
        return this.smallScreen || this.viewport.isMobile;
   }

    ngOnInit() {
        const deadline = new Date(); //today
        deadline.setHours(0, 0, 0, 0);
        deadline.setDate(deadline.getDate() + 1);

        this.setTimeRemaining(deadline);
        this.timerId = window.setInterval(() => this.setTimeRemaining(deadline), 1000);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes['displaySalesBanner'] ||
            changes['trialCode'] ||
            changes['trialDays'] ||
            changes['banner_txt']
        ) {
            this.shouldShowBanner = this.displaySalesBanner || (!!this.trialCode && !!this.trialDays);
            if (this.trialCode && this.trialDays) {
                this.bannerMessage = `Get ${this.trialDays}s for $1`;
            } else {
                this.bannerMessage = this.banner_txt;
            }
        }

    }

    ngOnDestroy(): void {
        if (this.timerId != null) {
            window.clearInterval(this.timerId);
        }
    }

    private setTimeRemaining(endTime: Date) {
        const now = new Date();
        const t = endTime.getTime() - now.getTime();
        if (t < 0) return;

        this.seconds = Math.floor((t / 1000) % 60);
        this.minutes = Math.floor((t / 1000 / 60) % 60);
        this.hours = Math.floor(t / (1000 * 60 * 60));
    }
}
